<div [ngClass]="{ disabled: disabled }" [classList]="topPosition" class="calendar-wrapper relative h-0">
  <mat-form-field class="invisible h-0">
    <input
      [name]="name"
      #mat_general_date="ngModel"
      (click)="picker.open()"
      (dateChange)="onDateChanged($event)"
      [(ngModel)]="dateModel"
      [matDatepicker]="picker"
      [min]="minStartDate"
      [max]="maxDate"
      [required]="required()"
      matInput
      readonly
    />
    <!--      [ngModelOptions]="{ standalone: true }"-->
    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker [startAt]="calendarOpenDate" #picker></mat-datepicker>
  </mat-form-field>
</div>

<!--todo tooltips-->
<!--<i-->
<!--  (click)="onIconClick($event)"-->
<!--  *ngIf="iconOptions?.showIcon"-->
<!--  [classList]="iconOptions?.icon"-->
<!--  [appTooltip]="iconOptions?.tooltip"-->
<!--  tooltipStyleClass="input-calendar-tooltip"-->
<!--  tooltipPosition="bottom"-->
<!--&gt;</i>-->

<app-floating-input
  [(ngModel)]="dateModel"
  type="date-custom"
  [required]="required()"
  class="calendar-input"
  [name]="name"
  [readonly]="true"
  [disabled]="disabled"
  (click)="picker.open()"
  [placeholder]="placeholder"
  [label]="showLabel ? placeholder : ''"
  [verticalSpacing]="showLabel"
  [iconClass]="iconOptions?.showIcon ? iconOptions?.icon : ''"
  [tooltipText]="iconOptions?.tooltip"
  tooltipPosition="bottom"
  [inputClass]="inputClass()"
  wrapperClass="test-wrapper-class"
>
</app-floating-input>
